
import { Payment } from "../types";

/**
 * Convert raw database record to Payment type
 */
export const mapToPayment = (record: any): Payment => {
  return {
    id: record.id,
    family_id: record.family_id,
    organization_id: record.organization_id,
    amount_cents: record.amount_cents,
    paid_at: record.paid_at,
    stripe_payment_intent: record.stripe_payment_intent,
    status: record.status || 'pending',
    receipt_url: record.receipt_url,
    // Additional fields for compatibility
    family_name: record.families?.name,
    // Ensure created_at is always provided
    created_at: record.created_at || new Date().toISOString(), 
    currency: record.currency || 'usd',
    payment_method: record.payment_method || 'card',
    customer_name: record.customer_name,
    customer_email: record.customer_email,
    description: record.description,
    // Derived field - should not be stored in database directly
    amount: record.amount_cents ? record.amount_cents / 100 : 0
  };
};

/**
 * Safely format payment amount for display
 */
export const formatPaymentAmount = (payment: Partial<Payment>): string => {
  if (!payment.amount_cents && payment.amount === undefined) {
    return '$0.00';
  }
  
  const amountValue = payment.amount !== undefined 
    ? payment.amount 
    : (payment.amount_cents ? payment.amount_cents / 100 : 0);
    
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: payment.currency?.toLowerCase() || 'usd',
  }).format(amountValue);
};

/**
 * Get payment status display text with appropriate styling class
 */
export const getPaymentStatusInfo = (status?: string): { text: string, colorClass: string } => {
  const normalizedStatus = (status || '').toLowerCase();
  
  switch (normalizedStatus) {
    case 'paid':
    case 'succeeded':
    case 'complete':
      return { text: 'Paid', colorClass: 'text-green-600' };
    case 'pending':
    case 'processing':
      return { text: 'Processing', colorClass: 'text-amber-600' };
    case 'failed':
    case 'canceled':
      return { text: 'Failed', colorClass: 'text-red-600' };
    case 'refunded':
      return { text: 'Refunded', colorClass: 'text-blue-600' };
    default:
      return { text: 'Unknown', colorClass: 'text-gray-600' };
  }
};
